import { mediaUrl } from "@/lib/api";
import { ConceptMap } from "@/components/ConceptMap";

export const TermPrintCard = ({ term: t, withComic }) => (
  <article className="break-inside-avoid rounded-2xl border-2 border-black bg-white p-5" data-testid={`print-term-${t.id}`}>
    <div className="flex items-baseline justify-between gap-3">
      <h2 className="font-display text-2xl font-bold">{t.word}</h2>
      <span className="text-xs font-extrabold uppercase tracking-wide text-neutral-600">{t.subject}</span>
    </div>
    <p className="mt-2 font-semibold leading-relaxed">{t.definition}</p>
    <ul className="mt-3 list-disc space-y-1 pl-5 text-sm">
      {t.examples.map((e, i) => <li key={i}>{e}</li>)}
    </ul>
    {t.curiosity && <p className="mt-3 text-sm"><b>Lo sapevi?</b> {t.curiosity}</p>}
    {withComic && t.comic_status === "ready" && (
      <img src={mediaUrl(t.comic_path)} alt={`Fumetto: ${t.word}`} className="mx-auto mt-4 max-h-[420px] rounded-xl border-2 border-black" />
    )}
    {t.map_status === "ready" && t.concept_map && (
      <div className="mt-4 break-inside-avoid"><ConceptMap map={t.concept_map} compact /></div>
    )}
  </article>
);
